// FE-only demo configuration. This repo IS the demo — mode is always on.
export const isDemoMode = true;

export const DEMO_EMAIL = 'demo@superstate.one';
export const DEMO_PASSWORD = 'Superstate1!';

export const demoUser = {
  id: 'demo-user-1',
  email: DEMO_EMAIL,
  mirage_username: 'demo',
  mirage_user_id: 1,
  full_name: 'Демо Потребител',
  is_active: true,
  is_superuser: true,
  role: 'admin',
  status: 'active',
  first_login_at: '2026-01-05T09:00:00Z',
  created_at: '2026-01-05T09:00:00Z',
  updated_at: '2026-01-05T09:00:00Z',
};
